// https://github.com/risan/country-flag-emoji

const CountryCodes = {
  AC: {
    code: 'AC',
    name: 'Ascension Island',
    emoji: '🇦🇨',
  },
  AD: {
    code: 'AD',
    name: 'Andorra',
    emoji: '🇦🇩',
  },
  AE: {
    code: 'AE',
    name: 'United Arab Emirates',
    emoji: '🇦🇪',
  },
  AF: {
    code: 'AF',
    name: 'Afghanistan',
    emoji: '🇦🇫',
  },
  AG: {
    code: 'AG',
    name: 'Antigua & Barbuda',
    emoji: '🇦🇬',
  },
  AI: {
    code: 'AI',
    name: 'Anguilla',
    emoji: '🇦🇮',
  },
  AL: {
    code: 'AL',
    name: 'Albania',
    emoji: '🇦🇱',
  },
  AM: {
    code: 'AM',
    name: 'Armenia',
    emoji: '🇦🇲',
  },
  AO: {
    code: 'AO',
    name: 'Angola',
    emoji: '🇦🇴',
  },
  AQ: {
    code: 'AQ',
    name: 'Antarctica',
    emoji: '🇦🇶',
  },
  AR: {
    code: 'AR',
    name: 'Argentina',
    emoji: '🇦🇷',
  },
  AS: {
    code: 'AS',
    name: 'American Samoa',
    emoji: '🇦🇸',
  },
  AT: {
    code: 'AT',
    name: 'Austria',
    emoji: '🇦🇹',
  },
  AU: {
    code: 'AU',
    name: 'Australia',
    emoji: '🇦🇺',
  },
  AW: {
    code: 'AW',
    name: 'Aruba',
    emoji: '🇦🇼',
  },
  AX: {
    code: 'AX',
    name: 'Åland Islands',
    emoji: '🇦🇽',
  },
  AZ: {
    code: 'AZ',
    name: 'Azerbaijan',
    emoji: '🇦🇿',
  },
  BA: {
    code: 'BA',
    name: 'Bosnia & Herzegovina',
    emoji: '🇧🇦',
  },
  BB: {
    code: 'BB',
    name: 'Barbados',
    emoji: '🇧🇧',
  },
  BD: {
    code: 'BD',
    name: 'Bangladesh',
    emoji: '🇧🇩',
  },
  BE: {
    code: 'BE',
    name: 'Belgium',
    emoji: '🇧🇪',
  },
  BF: {
    code: 'BF',
    name: 'Burkina Faso',
    emoji: '🇧🇫',
  },
  BG: {
    code: 'BG',
    name: 'Bulgaria',
    emoji: '🇧🇬',
  },
  BH: {
    code: 'BH',
    name: 'Bahrain',
    emoji: '🇧🇭',
  },
  BI: {
    code: 'BI',
    name: 'Burundi',
    emoji: '🇧🇮',
  },
  BJ: {
    code: 'BJ',
    name: 'Benin',
    emoji: '🇧🇯',
  },
  BL: {
    code: 'BL',
    name: 'St. Barthélemy',
    emoji: '🇧🇱',
  },
  BM: {
    code: 'BM',
    name: 'Bermuda',
    emoji: '🇧🇲',
  },
  BN: {
    code: 'BN',
    name: 'Brunei',
    emoji: '🇧🇳',
  },
  BO: {
    code: 'BO',
    name: 'Bolivia',
    emoji: '🇧🇴',
  },
  BQ: {
    code: 'BQ',
    name: 'Caribbean Netherlands',
    emoji: '🇧🇶',
  },
  BR: {
    code: 'BR',
    name: 'Brazil',
    emoji: '🇧🇷',
  },
  BS: {
    code: 'BS',
    name: 'Bahamas',
    emoji: '🇧🇸',
  },
  BT: {
    code: 'BT',
    name: 'Bhutan',
    emoji: '🇧🇹',
  },
  BV: {
    code: 'BV',
    name: 'Bouvet Island',
    emoji: '🇧🇻',
  },
  BW: {
    code: 'BW',
    name: 'Botswana',
    emoji: '🇧🇼',
  },
  BY: {
    code: 'BY',
    name: 'Belarus',
    emoji: '🇧🇾',
  },
  BZ: {
    code: 'BZ',
    name: 'Belize',
    emoji: '🇧🇿',
  },
  CA: {
    code: 'CA',
    name: 'Canada',
    emoji: '🇨🇦',
  },
  CC: {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
    emoji: '🇨🇨',
  },
  CD: {
    code: 'CD',
    name: 'Congo - Kinshasa',
    emoji: '🇨🇩',
  },
  CF: {
    code: 'CF',
    name: 'Central African Republic',
    emoji: '🇨🇫',
  },
  CG: {
    code: 'CG',
    name: 'Congo - Brazzaville',
    emoji: '🇨🇬',
  },
  CH: {
    code: 'CH',
    name: 'Switzerland',
    emoji: '🇨🇭',
  },
  CI: {
    code: 'CI',
    name: 'Côte d’Ivoire',
    emoji: '🇨🇮',
  },
  CK: {
    code: 'CK',
    name: 'Cook Islands',
    emoji: '🇨🇰',
  },
  CL: {
    code: 'CL',
    name: 'Chile',
    emoji: '🇨🇱',
  },
  CM: {
    code: 'CM',
    name: 'Cameroon',
    emoji: '🇨🇲',
  },
  CN: {
    code: 'CN',
    name: 'China',
    emoji: '🇨🇳',
  },
  CO: {
    code: 'CO',
    name: 'Colombia',
    emoji: '🇨🇴',
  },
  CP: {
    code: 'CP',
    name: 'Clipperton Island',
    emoji: '🇨🇵',
  },
  CR: {
    code: 'CR',
    name: 'Costa Rica',
    emoji: '🇨🇷',
  },
  CU: {
    code: 'CU',
    name: 'Cuba',
    emoji: '🇨🇺',
  },
  CV: {
    code: 'CV',
    name: 'Cape Verde',
    emoji: '🇨🇻',
  },
  CW: {
    code: 'CW',
    name: 'Curaçao',
    emoji: '🇨🇼',
  },
  CX: {
    code: 'CX',
    name: 'Christmas Island',
    emoji: '🇨🇽',
  },
  CY: {
    code: 'CY',
    name: 'Cyprus',
    emoji: '🇨🇾',
  },
  CZ: {
    code: 'CZ',
    name: 'Czechia',
    emoji: '🇨🇿',
  },
  DE: {
    code: 'DE',
    name: 'Germany',
    emoji: '🇩🇪',
  },
  DG: {
    code: 'DG',
    name: 'Diego Garcia',
    emoji: '🇩🇬',
  },
  DJ: {
    code: 'DJ',
    name: 'Djibouti',
    emoji: '🇩🇯',
  },
  DK: {
    code: 'DK',
    name: 'Denmark',
    emoji: '🇩🇰',
  },
  DM: {
    code: 'DM',
    name: 'Dominica',
    emoji: '🇩🇲',
  },
  DO: {
    code: 'DO',
    name: 'Dominican Republic',
    emoji: '🇩🇴',
  },
  DZ: {
    code: 'DZ',
    name: 'Algeria',
    emoji: '🇩🇿',
  },
  EA: {
    code: 'EA',
    name: 'Ceuta & Melilla',
    emoji: '🇪🇦',
  },
  EC: {
    code: 'EC',
    name: 'Ecuador',
    emoji: '🇪🇨',
  },
  EE: {
    code: 'EE',
    name: 'Estonia',
    emoji: '🇪🇪',
  },
  EG: {
    code: 'EG',
    name: 'Egypt',
    emoji: '🇪🇬',
  },
  EH: {
    code: 'EH',
    name: 'Western Sahara',
    emoji: '🇪🇭',
  },
  ER: {
    code: 'ER',
    name: 'Eritrea',
    emoji: '🇪🇷',
  },
  ES: {
    code: 'ES',
    name: 'Spain',
    emoji: '🇪🇸',
  },
  ET: {
    code: 'ET',
    name: 'Ethiopia',
    emoji: '🇪🇹',
  },
  EU: {
    code: 'EU',
    name: 'European Union',
    emoji: '🇪🇺',
  },
  FI: {
    code: 'FI',
    name: 'Finland',
    emoji: '🇫🇮',
  },
  FJ: {
    code: 'FJ',
    name: 'Fiji',
    emoji: '🇫🇯',
  },
  FK: {
    code: 'FK',
    name: 'Falkland Islands',
    emoji: '🇫🇰',
  },
  FM: {
    code: 'FM',
    name: 'Micronesia',
    emoji: '🇫🇲',
  },
  FO: {
    code: 'FO',
    name: 'Faroe Islands',
    emoji: '🇫🇴',
  },
  FR: {
    code: 'FR',
    name: 'France',
    emoji: '🇫🇷',
  },
  GA: {
    code: 'GA',
    name: 'Gabon',
    emoji: '🇬🇦',
  },
  GB: {
    code: 'GB',
    name: 'United Kingdom',
    emoji: '🇬🇧',
  },
  GD: {
    code: 'GD',
    name: 'Grenada',
    emoji: '🇬🇩',
  },
  GE: {
    code: 'GE',
    name: 'Georgia',
    emoji: '🇬🇪',
  },
  GF: {
    code: 'GF',
    name: 'French Guiana',
    emoji: '🇬🇫',
  },
  GG: {
    code: 'GG',
    name: 'Guernsey',
    emoji: '🇬🇬',
  },
  GH: {
    code: 'GH',
    name: 'Ghana',
    emoji: '🇬🇭',
  },
  GI: {
    code: 'GI',
    name: 'Gibraltar',
    emoji: '🇬🇮',
  },
  GL: {
    code: 'GL',
    name: 'Greenland',
    emoji: '🇬🇱',
  },
  GM: {
    code: 'GM',
    name: 'Gambia',
    emoji: '🇬🇲',
  },
  GN: {
    code: 'GN',
    name: 'Guinea',
    emoji: '🇬🇳',
  },
  GP: {
    code: 'GP',
    name: 'Guadeloupe',
    emoji: '🇬🇵',
  },
  GQ: {
    code: 'GQ',
    name: 'Equatorial Guinea',
    emoji: '🇬🇶',
  },
  GR: {
    code: 'GR',
    name: 'Greece',
    emoji: '🇬🇷',
  },
  GS: {
    code: 'GS',
    name: 'South Georgia & South Sandwich Islands',
    emoji: '🇬🇸',
  },
  GT: {
    code: 'GT',
    name: 'Guatemala',
    emoji: '🇬🇹',
  },
  GU: {
    code: 'GU',
    name: 'Guam',
    emoji: '🇬🇺',
  },
  GW: {
    code: 'GW',
    name: 'Guinea-Bissau',
    emoji: '🇬🇼',
  },
  GY: {
    code: 'GY',
    name: 'Guyana',
    emoji: '🇬🇾',
  },
  HK: {
    code: 'HK',
    name: 'Hong Kong SAR China',
    emoji: '🇭🇰',
  },
  HM: {
    code: 'HM',
    name: 'Heard & McDonald Islands',
    emoji: '🇭🇲',
  },
  HN: {
    code: 'HN',
    name: 'Honduras',
    emoji: '🇭🇳',
  },
  HR: {
    code: 'HR',
    name: 'Croatia',
    emoji: '🇭🇷',
  },
  HT: {
    code: 'HT',
    name: 'Haiti',
    emoji: '🇭🇹',
  },
  HU: {
    code: 'HU',
    name: 'Hungary',
    emoji: '🇭🇺',
  },
  IC: {
    code: 'IC',
    name: 'Canary Islands',
    emoji: '🇮🇨',
  },
  ID: {
    code: 'ID',
    name: 'Indonesia',
    emoji: '🇮🇩',
  },
  IE: {
    code: 'IE',
    name: 'Ireland',
    emoji: '🇮🇪',
  },
  IL: {
    code: 'IL',
    name: 'Israel',
    emoji: '🇮🇱',
  },
  IM: {
    code: 'IM',
    name: 'Isle of Man',
    emoji: '🇮🇲',
  },
  IN: {
    code: 'IN',
    name: 'India',
    emoji: '🇮🇳',
  },
  IO: {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    emoji: '🇮🇴',
  },
  IQ: {
    code: 'IQ',
    name: 'Iraq',
    emoji: '🇮🇶',
  },
  IR: {
    code: 'IR',
    name: 'Iran',
    emoji: '🇮🇷',
  },
  IS: {
    code: 'IS',
    name: 'Iceland',
    emoji: '🇮🇸',
  },
  IT: {
    code: 'IT',
    name: 'Italy',
    emoji: '🇮🇹',
  },
  JE: {
    code: 'JE',
    name: 'Jersey',
    emoji: '🇯🇪',
  },
  JM: {
    code: 'JM',
    name: 'Jamaica',
    emoji: '🇯🇲',
  },
  JO: {
    code: 'JO',
    name: 'Jordan',
    emoji: '🇯🇴',
  },
  JP: {
    code: 'JP',
    name: 'Japan',
    emoji: '🇯🇵',
  },
  KE: {
    code: 'KE',
    name: 'Kenya',
    emoji: '🇰🇪',
  },
  KG: {
    code: 'KG',
    name: 'Kyrgyzstan',
    emoji: '🇰🇬',
  },
  KH: {
    code: 'KH',
    name: 'Cambodia',
    emoji: '🇰🇭',
  },
  KI: {
    code: 'KI',
    name: 'Kiribati',
    emoji: '🇰🇮',
  },
  KM: {
    code: 'KM',
    name: 'Comoros',
    emoji: '🇰🇲',
  },
  KN: {
    code: 'KN',
    name: 'St. Kitts & Nevis',
    emoji: '🇰🇳',
  },
  KP: {
    code: 'KP',
    name: 'North Korea',
    emoji: '🇰🇵',
  },
  KR: {
    code: 'KR',
    name: 'South Korea',
    emoji: '🇰🇷',
  },
  KW: {
    code: 'KW',
    name: 'Kuwait',
    emoji: '🇰🇼',
  },
  KY: {
    code: 'KY',
    name: 'Cayman Islands',
    emoji: '🇰🇾',
  },
  KZ: {
    code: 'KZ',
    name: 'Kazakhstan',
    emoji: '🇰🇿',
  },
  LA: {
    code: 'LA',
    name: 'Laos',
    emoji: '🇱🇦',
  },
  LB: {
    code: 'LB',
    name: 'Lebanon',
    emoji: '🇱🇧',
  },
  LC: {
    code: 'LC',
    name: 'St. Lucia',
    emoji: '🇱🇨',
  },
  LI: {
    code: 'LI',
    name: 'Liechtenstein',
    emoji: '🇱🇮',
  },
  LK: {
    code: 'LK',
    name: 'Sri Lanka',
    emoji: '🇱🇰',
  },
  LR: {
    code: 'LR',
    name: 'Liberia',
    emoji: '🇱🇷',
  },
  LS: {
    code: 'LS',
    name: 'Lesotho',
    emoji: '🇱🇸',
  },
  LT: {
    code: 'LT',
    name: 'Lithuania',
    emoji: '🇱🇹',
  },
  LU: {
    code: 'LU',
    name: 'Luxembourg',
    emoji: '🇱🇺',
  },
  LV: {
    code: 'LV',
    name: 'Latvia',
    emoji: '🇱🇻',
  },
  LY: {
    code: 'LY',
    name: 'Libya',
    emoji: '🇱🇾',
  },
  MA: {
    code: 'MA',
    name: 'Morocco',
    emoji: '🇲🇦',
  },
  MC: {
    code: 'MC',
    name: 'Monaco',
    emoji: '🇲🇨',
  },
  MD: {
    code: 'MD',
    name: 'Moldova',
    emoji: '🇲🇩',
  },
  ME: {
    code: 'ME',
    name: 'Montenegro',
    emoji: '🇲🇪',
  },
  MF: {
    code: 'MF',
    name: 'St. Martin',
    emoji: '🇲🇫',
  },
  MG: {
    code: 'MG',
    name: 'Madagascar',
    emoji: '🇲🇬',
  },
  MH: {
    code: 'MH',
    name: 'Marshall Islands',
    emoji: '🇲🇭',
  },
  MK: {
    code: 'MK',
    name: 'Macedonia',
    emoji: '🇲🇰',
  },
  ML: {
    code: 'ML',
    name: 'Mali',
    emoji: '🇲🇱',
  },
  MM: {
    code: 'MM',
    name: 'Myanmar (Burma)',
    emoji: '🇲🇲',
  },
  MN: {
    code: 'MN',
    name: 'Mongolia',
    emoji: '🇲🇳',
  },
  MO: {
    code: 'MO',
    name: 'Macau SAR China',
    emoji: '🇲🇴',
  },
  MP: {
    code: 'MP',
    name: 'Northern Mariana Islands',
    emoji: '🇲🇵',
  },
  MQ: {
    code: 'MQ',
    name: 'Martinique',
    emoji: '🇲🇶',
  },
  MR: {
    code: 'MR',
    name: 'Mauritania',
    emoji: '🇲🇷',
  },
  MS: {
    code: 'MS',
    name: 'Montserrat',
    emoji: '🇲🇸',
  },
  MT: {
    code: 'MT',
    name: 'Malta',
    emoji: '🇲🇹',
  },
  MU: {
    code: 'MU',
    name: 'Mauritius',
    emoji: '🇲🇺',
  },
  MV: {
    code: 'MV',
    name: 'Maldives',
    emoji: '🇲🇻',
  },
  MW: {
    code: 'MW',
    name: 'Malawi',
    emoji: '🇲🇼',
  },
  MX: {
    code: 'MX',
    name: 'Mexico',
    emoji: '🇲🇽',
  },
  MY: {
    code: 'MY',
    name: 'Malaysia',
    emoji: '🇲🇾',
  },
  MZ: {
    code: 'MZ',
    name: 'Mozambique',
    emoji: '🇲🇿',
  },
  NA: {
    code: 'NA',
    name: 'Namibia',
    emoji: '🇳🇦',
  },
  NC: {
    code: 'NC',
    name: 'New Caledonia',
    emoji: '🇳🇨',
  },
  NE: {
    code: 'NE',
    name: 'Niger',
    emoji: '🇳🇪',
  },
  NF: {
    code: 'NF',
    name: 'Norfolk Island',
    emoji: '🇳🇫',
  },
  NG: {
    code: 'NG',
    name: 'Nigeria',
    emoji: '🇳🇬',
  },
  NI: {
    code: 'NI',
    name: 'Nicaragua',
    emoji: '🇳🇮',
  },
  NL: {
    code: 'NL',
    name: 'Netherlands',
    emoji: '🇳🇱',
  },
  NO: {
    code: 'NO',
    name: 'Norway',
    emoji: '🇳🇴',
  },
  NP: {
    code: 'NP',
    name: 'Nepal',
    emoji: '🇳🇵',
  },
  NR: {
    code: 'NR',
    name: 'Nauru',
    emoji: '🇳🇷',
  },
  NU: {
    code: 'NU',
    name: 'Niue',
    emoji: '🇳🇺',
  },
  NZ: {
    code: 'NZ',
    name: 'New Zealand',
    emoji: '🇳🇿',
  },
  OM: {
    code: 'OM',
    name: 'Oman',
    emoji: '🇴🇲',
  },
  PA: {
    code: 'PA',
    name: 'Panama',
    emoji: '🇵🇦',
  },
  PE: {
    code: 'PE',
    name: 'Peru',
    emoji: '🇵🇪',
  },
  PF: {
    code: 'PF',
    name: 'French Polynesia',
    emoji: '🇵🇫',
  },
  PG: {
    code: 'PG',
    name: 'Papua New Guinea',
    emoji: '🇵🇬',
  },
  PH: {
    code: 'PH',
    name: 'Philippines',
    emoji: '🇵🇭',
  },
  PK: {
    code: 'PK',
    name: 'Pakistan',
    emoji: '🇵🇰',
  },
  PL: {
    code: 'PL',
    name: 'Poland',
    emoji: '🇵🇱',
  },
  PM: {
    code: 'PM',
    name: 'St. Pierre & Miquelon',
    emoji: '🇵🇲',
  },
  PN: {
    code: 'PN',
    name: 'Pitcairn Islands',
    emoji: '🇵🇳',
  },
  PR: {
    code: 'PR',
    name: 'Puerto Rico',
    emoji: '🇵🇷',
  },
  PS: {
    code: 'PS',
    name: 'Palestinian Territories',
    emoji: '🇵🇸',
  },
  PT: {
    code: 'PT',
    name: 'Portugal',
    emoji: '🇵🇹',
  },
  PW: {
    code: 'PW',
    name: 'Palau',
    emoji: '🇵🇼',
  },
  PY: {
    code: 'PY',
    name: 'Paraguay',
    emoji: '🇵🇾',
  },
  QA: {
    code: 'QA',
    name: 'Qatar',
    emoji: '🇶🇦',
  },
  RE: {
    code: 'RE',
    name: 'Réunion',
    emoji: '🇷🇪',
  },
  RO: {
    code: 'RO',
    name: 'Romania',
    emoji: '🇷🇴',
  },
  RS: {
    code: 'RS',
    name: 'Serbia',
    emoji: '🇷🇸',
  },
  RU: {
    code: 'RU',
    name: 'Russia',
    emoji: '🇷🇺',
  },
  RW: {
    code: 'RW',
    name: 'Rwanda',
    emoji: '🇷🇼',
  },
  SA: {
    code: 'SA',
    name: 'Saudi Arabia',
    emoji: '🇸🇦',
  },
  SB: {
    code: 'SB',
    name: 'Solomon Islands',
    emoji: '🇸🇧',
  },
  SC: {
    code: 'SC',
    name: 'Seychelles',
    emoji: '🇸🇨',
  },
  SD: {
    code: 'SD',
    name: 'Sudan',
    emoji: '🇸🇩',
  },
  SE: {
    code: 'SE',
    name: 'Sweden',
    emoji: '🇸🇪',
  },
  SG: {
    code: 'SG',
    name: 'Singapore',
    emoji: '🇸🇬',
  },
  SH: {
    code: 'SH',
    name: 'St. Helena',
    emoji: '🇸🇭',
  },
  SI: {
    code: 'SI',
    name: 'Slovenia',
    emoji: '🇸🇮',
  },
  SJ: {
    code: 'SJ',
    name: 'Svalbard & Jan Mayen',
    emoji: '🇸🇯',
  },
  SK: {
    code: 'SK',
    name: 'Slovakia',
    emoji: '🇸🇰',
  },
  SL: {
    code: 'SL',
    name: 'Sierra Leone',
    emoji: '🇸🇱',
  },
  SM: {
    code: 'SM',
    name: 'San Marino',
    emoji: '🇸🇲',
  },
  SN: {
    code: 'SN',
    name: 'Senegal',
    emoji: '🇸🇳',
  },
  SO: {
    code: 'SO',
    name: 'Somalia',
    emoji: '🇸🇴',
  },
  SR: {
    code: 'SR',
    name: 'Suriname',
    emoji: '🇸🇷',
  },
  SS: {
    code: 'SS',
    name: 'South Sudan',
    emoji: '🇸🇸',
  },
  ST: {
    code: 'ST',
    name: 'São Tomé & Príncipe',
    emoji: '🇸🇹',
  },
  SV: {
    code: 'SV',
    name: 'El Salvador',
    emoji: '🇸🇻',
  },
  SX: {
    code: 'SX',
    name: 'Sint Maarten',
    emoji: '🇸🇽',
  },
  SY: {
    code: 'SY',
    name: 'Syria',
    emoji: '🇸🇾',
  },
  SZ: {
    code: 'SZ',
    name: 'Swaziland',
    emoji: '🇸🇿',
  },
  TA: {
    code: 'TA',
    name: 'Tristan da Cunha',
    emoji: '🇹🇦',
  },
  TC: {
    code: 'TC',
    name: 'Turks & Caicos Islands',
    emoji: '🇹🇨',
  },
  TD: {
    code: 'TD',
    name: 'Chad',
    emoji: '🇹🇩',
  },
  TF: {
    code: 'TF',
    name: 'French Southern Territories',
    emoji: '🇹🇫',
  },
  TG: {
    code: 'TG',
    name: 'Togo',
    emoji: '🇹🇬',
  },
  TH: {
    code: 'TH',
    name: 'Thailand',
    emoji: '🇹🇭',
  },
  TJ: {
    code: 'TJ',
    name: 'Tajikistan',
    emoji: '🇹🇯',
  },
  TK: {
    code: 'TK',
    name: 'Tokelau',
    emoji: '🇹🇰',
  },
  TL: {
    code: 'TL',
    name: 'Timor-Leste',
    emoji: '🇹🇱',
  },
  TM: {
    code: 'TM',
    name: 'Turkmenistan',
    emoji: '🇹🇲',
  },
  TN: {
    code: 'TN',
    name: 'Tunisia',
    emoji: '🇹🇳',
  },
  TO: {
    code: 'TO',
    name: 'Tonga',
    emoji: '🇹🇴',
  },
  TR: {
    code: 'TR',
    name: 'Turkey',
    emoji: '🇹🇷',
  },
  TT: {
    code: 'TT',
    name: 'Trinidad & Tobago',
    emoji: '🇹🇹',
  },
  TV: {
    code: 'TV',
    name: 'Tuvalu',
    emoji: '🇹🇻',
  },
  TW: {
    code: 'TW',
    name: 'Taiwan',
    emoji: '🇹🇼',
  },
  TZ: {
    code: 'TZ',
    name: 'Tanzania',
    emoji: '🇹🇿',
  },
  UA: {
    code: 'UA',
    name: 'Ukraine',
    emoji: '🇺🇦',
  },
  UG: {
    code: 'UG',
    name: 'Uganda',
    emoji: '🇺🇬',
  },
  UM: {
    code: 'UM',
    name: 'U.S. Outlying Islands',
    emoji: '🇺🇲',
  },
  UN: {
    code: 'UN',
    name: 'United Nations',
    emoji: '🇺🇳',
  },
  US: {
    code: 'US',
    name: 'United States',
    emoji: '🇺🇸',
  },
  UY: {
    code: 'UY',
    name: 'Uruguay',
    emoji: '🇺🇾',
  },
  UZ: {
    code: 'UZ',
    name: 'Uzbekistan',
    emoji: '🇺🇿',
  },
  VA: {
    code: 'VA',
    name: 'Vatican City',
    emoji: '🇻🇦',
  },
  VC: {
    code: 'VC',
    name: 'St. Vincent & Grenadines',
    emoji: '🇻🇨',
  },
  VE: {
    code: 'VE',
    name: 'Venezuela',
    emoji: '🇻🇪',
  },
  VG: {
    code: 'VG',
    name: 'British Virgin Islands',
    emoji: '🇻🇬',
  },
  VI: {
    code: 'VI',
    name: 'U.S. Virgin Islands',
    emoji: '🇻🇮',
  },
  VN: {
    code: 'VN',
    name: 'Vietnam',
    emoji: '🇻🇳',
  },
  VU: {
    code: 'VU',
    name: 'Vanuatu',
    emoji: '🇻🇺',
  },
  WF: {
    code: 'WF',
    name: 'Wallis & Futuna',
    emoji: '🇼🇫',
  },
  WS: {
    code: 'WS',
    name: 'Samoa',
    emoji: '🇼🇸',
  },
  XK: {
    code: 'XK',
    name: 'Kosovo',
    emoji: '🇽🇰',
  },
  YE: {
    code: 'YE',
    name: 'Yemen',
    emoji: '🇾🇪',
  },
  YT: {
    code: 'YT',
    name: 'Mayotte',
    emoji: '🇾🇹',
  },
  ZA: {
    code: 'ZA',
    name: 'South Africa',
    emoji: '🇿🇦',
  },
  ZM: {
    code: 'ZM',
    name: 'Zambia',
    emoji: '🇿🇲',
  },
  ZW: {
    code: 'ZW',
    name: 'Zimbabwe',
    emoji: '🇿🇼',
  },
}

export default CountryCodes
